import {$applyNodeReplacement, DecoratorNode, DOMConversionMap, NodeKey} from 'lexical';
import {ReactNode as ReactNodeType} from 'react';

import styles from './EnhancedHeadingNode.module.css';
import {HeadingControls} from './HeadingControls';

export class HeadingChevronDecoratorNode extends DecoratorNode<ReactNodeType> {
  __headingId: string;

  static getType(): string {
    return 'HeadingChevron';
  }

  static importDOM(): DOMConversionMap | null {
    return null;
  }

  static clone(node: HeadingChevronDecoratorNode): HeadingChevronDecoratorNode {
    return new HeadingChevronDecoratorNode(node.__headingId, node.__key);
  }

  static importJSON(serializedNode: any): HeadingChevronDecoratorNode {
    const {headingId} = serializedNode;
    return new HeadingChevronDecoratorNode(headingId);
  }

  constructor(headingId: string = '', key?: NodeKey) {
    super(key);
    this.__headingId = headingId;
  }

  createDOM(): HTMLElement {
    const element = document.createElement('span');
    element.setAttribute('data-lexical-heading-chevron', 'true');
    element.classList.add(styles.chevron);

    return element;
  }

  updateDOM(): boolean {
    return false;
  }

  getHeadingId(): string {
    return this.__headingId;
  }

  setHeadingId(headingId: string): void {
    const writable = this.getWritable();
    writable.__headingId = headingId;
  }

  exportJSON(): any {
    return {
      ...super.exportJSON(),
      type: 'HeadingChevron',
      headingId: this.__headingId,
    };
  }

  component(): ReactNodeType {
    return null;
  }

  isKeyboardSelectable(): boolean {
    // Make this node non-navigable with keyboard
    return false;
  }

  isIsolated(): boolean {
    // Make this node behave as a single, indivisible unit
    // This prevents the cursor from entering the node during navigation
    return true;
  }

  // isInline(): boolean {
  //   // Make this node inline so it doesn't create line breaks
  //   return true;
  // }

  // canBeEmpty(): boolean {
  //   // Allow this node to be empty
  //   return true;
  // }

  // canInsertTextBefore(): boolean {
  //   // Prevent text insertion before this node
  //   return false;
  // }

  // canInsertTextAfter(): boolean {
  //   // Prevent text insertion after this node
  //   return false;
  // }

  decorate(): ReactNodeType {
    return <HeadingControls headingId={this.__headingId} />;
  }
}

export function $createHeadingChevronDecoratorNode(headingId: string): HeadingChevronDecoratorNode {
  return $applyNodeReplacement(new HeadingChevronDecoratorNode(headingId));
}

export function $isHeadingChevronDecoratorNode(node: unknown): node is HeadingChevronDecoratorNode {
  return node instanceof HeadingChevronDecoratorNode;
}
